<template>
  <div
    id="app"
    v-if="!loadingInit"
    :class="isRTL ? 'ArFont' : 'EnFont'"
  >
    <transition mode="out-in" name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AOS from 'aos';
// import { i18n } from '@/i18n';
import i18n from '@/vueI18n';

export default {
  name: 'app',
  // head() {
  //   return {
  //     // To use "this" in the component, it is necessary to return the object through a function
  //     title: function () {
  //       return {
  //         // inner: `${i18n('app.title')} | ${i18n('meta.title')} `
  //         inner: i18n('app.title'),
  //         separator: '|',
  //         complement: i18n('meta.title')
  //       }
  //     },
  //     meta: [
  //       // [ Primary Meta Tags ] ==> Essential META Tags
  //       { name: 'title', content: i18n('meta.title') },
  //       { name: 'description', content: i18n('meta.description') },

  //       // [ Open Graph / Facebook ] ==> Essential META Tags
  //       { property: 'fb:app_id', content: '420437041932657' },
  //       { property: 'og:url', content: localStorage.getItem('language') == 'ar' ? 'https://ar.saryahapp.com' : 'https://saryahapp.com' },
  //       { property: 'og:type', content: 'website' },
  //       { property: 'og:title', content: i18n('meta.title') },
  //       { property: 'og:description', content: i18n('meta.description') },
  //       { property: 'og:image', itemprop: 'image', content: 'https://firebasestorage.googleapis.com/v0/b/saryah-31e36.appspot.com/o/Shareable-Images%2Ffacebook.png?alt=media&token=1998b19a-e5c9-4be9-add6-f7f904619392' },

  //       // [ Open Graph / Whatsapp ] ==> Essential META Tags
  //       { property: 'og:image', content: 'https://firebasestorage.googleapis.com/v0/b/saryah-31e36.appspot.com/o/shareable-images%2Fsaryah-website%2Fwhatsapp.png?alt=media&token=809a8fed-8d53-4d32-9bfe-9f707f239ed2' },
  //       { property: 'og:image:type', content: '' },
  //       { property: 'og:image:width', content: '400' },
  //       { property: 'og:image:height', content: '400' },

  //       // [ Twitter ] ==> Essential META Tags
  //       { property: 'twitter:card', content: 'summary_large_image' },
  //       { property: 'twitter:url', content: localStorage.getItem('language') == 'ar' ? 'https://ar.saryahapp.com' : 'https://saryahapp.com' },
  //       { property: 'twitter:title', content: i18n('meta.title') },
  //       { property: 'twitter:description', content: i18n('meta.description') },
  //       { property: 'twitter:image', content: 'https://firebasestorage.googleapis.com/v0/b/saryah-31e36.appspot.com/o/Shareable-Images%2Ftwitter.png?alt=media&token=f3adc48c-4b27-4b8f-806c-b964326bfde6' },

  //       // Google / Schema.org markup:
  //       { itemprop: 'name', content: i18n('meta.title') },
  //       { itemprop: 'description', content: i18n('meta.description') },
  //       { itemprop: 'image', content: 'https://www.my-site.com/my-special-image.jpg' },
  //     ],
  //     link: [
  //       { itemprop: 'thumbnailUrl', href: 'https://firebasestorage.googleapis.com/v0/b/saryah-31e36.appspot.com/o/shareable-images%2Fsaryah-website%2Fwhatsapp.png?alt=media&token=809a8fed-8d53-4d32-9bfe-9f707f239ed2' },
  //       { rel: 'canonical', href: 'https://saryahapp.com' },
  //       { rel: 'alternate', hreflang: 'ar', href: 'https://ar.saryahapp.com' },
  //       { rel: 'alternate', hreflang: 'en', href: 'https://saryahapp.com' },
  //     ],
  //   }
  // },

  // metaInfo() {
  //   return {
  //     title: i18n('metaTitle.mainTitle'),
  //     meta: [
  //       { charset: 'utf-8' },
  //       {
  //         key: 'title',
  //         name: 'title',
  //         content: i18n('meta.title'),
  //       },
  //       {
  //         key: 'description',
  //         name: 'description',
  //         content: i18n('meta.description'),
  //       },
  //       {
  //         key: 'og:title',
  //         // name: 'og:title',
  //         property: 'og:title',
  //         content: i18n('meta.title'),
  //       },
  //       {
  //         key: 'og:description',
  //         // name: 'og:description',
  //         property: 'og:description',
  //         content: i18n('meta.description'),
  //       },
  //       {
  //         key: 'twitter:title',
  //         // name: 'twitter:title',
  //         property: 'twitter:title',
  //         content: i18n('meta.title'),
  //       },
  //       {
  //         key: 'twitter:description',
  //         // name: 'twitter:description',
  //         property: 'twitter:description',
  //         content: i18n('meta.description'),
  //       },
  //     ]
  //   }
  // },

  data() {
    return {
      urlAr: 'https://ar.saryahapp.com',
      urlEn: 'https://saryahapp.com',
      // lang: '',
      //  lang: this.$q.lang.isoName
    };
  },
  created() {
    AOS.init({
      once: false,
    });
    const promises = [
      new Promise(() => this.doInitFirebase()),
      new Promise(() => this.doInit()),
    ];
    Promise.all(promises);
    // await this.doInit();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapActions({
      doInitFirebase: 'auth/doInitFirebase',
      doInit: 'auth/doInit',
      resize: 'saryahLanding/layout/resize',
    }),
    handleResize() {
      this.resize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    },
    toggleNavOpen() {
      let root = document.getElementsByTagName('html')[0];
      root.classList.toggle('nav-open');
    },
  },
  mounted() {
    this.$watch('$sidebar.showSidebar', this.toggleNavOpen);
    // switch language
    if (localStorage.getItem('language') == 'ar') {
      // this.$rtl.enableRTL() ;
      import('quasar/lang/ar').then((lang) => {
        this.$q.lang.set(lang.default);
      });
    }
    if (localStorage.getItem('language') == 'en') {
      // this.$rtl.disableRTL() ;
      import('quasar/lang/en-us').then((lang) => {
        this.$q.lang.set(lang.default);
      });
    }
  },
  computed: {
    ...mapGetters({
      loadingInit: 'auth/loadingInit',
    }),
    isRTL() {
      return i18n.locale == 'ar';
      // return localStorage.getItem('language') == 'ar'
    },
    locale() {
      // this.lang = localStorage.getItem('language')
      // console.log('locale: ', localStorage.getItem('language'))
      return localStorage.getItem('language');
    },
    lang() {
      return i18n.locale;
    },
  },
  watch: {
    locale() {
      // console.log('Entered Watch in App.vue => ', newValue)
      this.$router
        .replace({ params: { lang: this.locale } })
        .catch(() => {});
    },
    lang(newVal, oldVal) {
      // debugger
      console.log('lang old value', oldVal);
      console.log('lang new value', newVal);

      if (newVal == 'ar') {
        document
          .getElementsByTagName('html')[0]
          .setAttribute('dir', 'rtl');
        this.$q.lang.rtl = true;
      }
      if (newVal == 'en') {
        document
          .getElementsByTagName('html')[0]
          .setAttribute('dir', 'ltr');
        this.$q.lang.rtl = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,200;0,300;0,400;0,600;0,900;1,100;1,200;1,300;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Almarai:wght@300;400;700;800&display=swap');
// @import url('https://fonts.googleapis.com/css2?family=Arial:ital,wght@0,100;0,200;0,300;0,400;0,600;0,900;1,100;1,200;1,300;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;0,1000;1,200;1,300;1,400;1,500;1,600;1,700;1,800&family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap');

a {
  outline: none !important;
  text-decoration: none !important;
}

.el-loading-spinner .path {
  stroke: #da3b30 !important;
}
*,
html {
  scroll-behavior: smooth !important;
}
body {
  margin: 0;
  background-color: unset !important;
}

/* body {
  font-family: 'Poppins', sans-serif !important;
} */
.q-table {
  max-width: unset !important;
}

.q-loading-bar .q-loading-bar--top .bg-red {
  display: none !important;
}

.bg-red {
  background: cyan !important;
}

.el-notification__content p {
  color: #36b1bf !important;
}

.ArFont {
  font-family: 'Almarai', sans-serif !important;
  // font-family: 'Tajawal', sans-serif !important;
}

.EnFont {
  font-family: 'Nunito', sans-serif !important;
}

// [dir=ltr] body {
//    font-family: 'Cairo', sans-serif!important;
// }
// [dir=rtl] body {
//   font-family: 'Cairo', sans-serif !important;
// }
.el-select .el-tag__close.el-icon-close {
  right: unset !important;
}

li {
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  html {
    font-size: 12px;
  }
}

@media screen and (min-width: 600px) and (max-width: 900px) {
  html {
    font-size: 15px;
  }
}

@media screen and (min-width: 900px) and (max-width: 1000) {
  html {
    font-size: 18px;
  }
}

@media screen and (min-width: 1000) {
  html {
    font-size: 30px;
  }
}

h1 {
  font-size: 3.5rem !important;
  font-weight: bold !important;
}

h2 {
  font-size: 2.5rem !important;
  font-weight: bold !important;
  margin-bottom: 3% !important;
}

h5 {
  font-size: 1.2rem !important;
}

.fontResize {
  font-size: calc(
    var(--minFontPx) + (var(--maxFont) - var(--minFont)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
  line-height: calc(
    var(--minLineHeightPx) +
      (var(--maxLineHeight) - var(--minLineHeight)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
}

.widthResize {
  width: calc(
    var(--minWidthPx) + (var(--maxWidth) - var(--minWidth)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
}

.heightResize {
  height: calc(
    var(--minHeightPx) +
      (var(--maxHeight) - var(--minHeight)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
}

.paddingResize {
  padding-right: calc(
    var(--minPaddingRPx) +
      (var(--maxPaddingR) - var(--minPaddingR)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
  padding-left: calc(
    var(--minPaddingLPx) +
      (var(--maxPaddingL) - var(--minPaddingL)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
  padding-top: calc(
    var(--minPaddingTPx) +
      (var(--maxPaddingT) - var(--minPaddingT)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
  padding-bottom: calc(
    var(--minPaddingBPx) +
      (var(--maxPaddingB) - var(--minPaddingB)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
}

.marginResize {
  margin-right: calc(
    var(--minMarginRPx) +
      (var(--maxMarginR) - var(--minMarginR)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
  margin-left: calc(
    var(--minMarginLPx) +
      (var(--maxMarginL) - var(--minMarginL)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
  margin-top: calc(
    var(--minMarginTPx) +
      (var(--maxMarginT) - var(--minMarginT)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
  margin-bottom: calc(
    var(--minMarginBPx) +
      (var(--maxMarginB) - var(--minMarginB)) *
      ((100vw - 375px) / (1440 - 375))
  ) !important;
}
</style>

<style lang="scss">
body {
  overflow-x: hidden !important;
}
.main-title {
  font-size: 50px !important;
  text-align: center;
  line-height: 1.2;
  max-width: 700px;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 20px;
  font-weight: 900;
  color: rgb(33, 33, 42) !important;
}
@media (width < 768px) {
  .main-title {
    font-size: 33px !important;
    margin-top: 50px;
    margin-bottom: 20px;
  }
}

.buttons {
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 40px;
  margin: auto;
}

.download-container {
  background: rgb(48, 48, 48);
  color: white;
  display: flex;
  align-items: center;

  gap: 30px;
  padding: 10px 25px;
  border-radius: 10px;
  cursor: pointer;
  filter: drop-shadow(0px 20px 10px rgba(50, 50, 50, 0.1))
    drop-shadow(0 8px 5px rgba(0, 0, 0, 0.2));
}
.download-container .icon img {
  height: 35px;
}
.download-container p,
h5 {
  margin: 0px !important;
  line-height: unset;
}
.download-container p {
  font-size: 16px;
}
h5 {
  font-size: 22px !important;
}
@media (width < 768px) {
  .buttons {
    margin-top: 20px;
    gap: 20px;
  }

  .download-container {
    gap: 20px;
    padding: 8px 20px;
    filter: drop-shadow(
        0px 20px 10px rgba(50, 50, 50, 0.02)
      )
      drop-shadow(0 8px 5px rgba(0, 0, 0, 0.02));
  }
  .download-container .icon img {
    height: 20px;
  }
  .download-container p,
  h5 {
    margin: 0px !important;
  }
  .download-container p {
    font-size: 12px;
  }
  h5 {
    font-size: 14px !important;
  }
}
.layout-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 80px;
  padding-right: 80px;
}

@media (max-width: 1024px) {
  .layout-container {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (max-width: 500px) {
  .layout-container {
    padding-left: 8px;
    padding-right: 8px;
  }
}

body::-webkit-scrollbar {
  width: 8px !important;
  // color: $Pelorous !important;
  // background: $Pelorous;
  border-radius: 50px;
}

body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}

body::-webkit-scrollbar-thumb {
  border-radius: 50px;
  background-color: #da3b30 !important;
  // outline: 5px solid greenyellow !important;
}

.disableScroll {
  position: fixed;
  overflow: hidden !important;
}
</style>